// extracted by mini-css-extract-plugin
export default {"divider":"style_divider__MED5F","divider--horizontal":"style_divider--horizontal__zF2Lv","divider--vertical":"style_divider--vertical__2HKdH","text":"style_text__R+kZs"};